import { useColorModeValue } from '@chakra-ui/react';

export const useSelectStyles = () => {
  const inputBg = useColorModeValue('white', 'gray.700');
  const inputTextColor = useColorModeValue('gray.800', 'white');
  const borderColor = useColorModeValue('gray.200', 'gray.700');
  const hoverBorderColor = useColorModeValue('blue.400', 'blue.300');
  const focusBorderColor = useColorModeValue('blue.500', 'blue.400');
  const inputPlaceholderColor = useColorModeValue('gray.500', 'gray.400');
  const modalBg = useColorModeValue('white', 'gray.800');
  const modalTextColor = useColorModeValue('gray.800', 'white');

  return {
    control: (base, state) => ({
      ...base,
      backgroundColor: inputBg,
      color: inputTextColor,
      borderColor: state.isFocused ? focusBorderColor : borderColor,
      borderWidth: '1px',
      borderRadius: 'lg',
      boxShadow: state.isFocused ? `0 0 0 1px ${focusBorderColor}` : 'none',
      '&:hover': {
        borderColor: state.isFocused ? focusBorderColor : hoverBorderColor,
      },
      minHeight: '40px',
      fontSize: '14px',
    }),
    menu: (base) => ({
      ...base,
      backgroundColor: modalBg,
      color: modalTextColor,
      borderRadius: 'lg',
      border: '1px solid',
      borderColor: borderColor,
      boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)',
      zIndex: 9999,
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? `${focusBorderColor} !important`
        : state.isFocused
        ? '#edf2f7'
        : 'transparent',
      color: state.isSelected ? 'white' : modalTextColor,
      fontSize: '14px',
      padding: '10px 12px',
      '&:hover': {
        backgroundColor: state.isSelected ? focusBorderColor : '#edf2f7',
      },
    }),
    singleValue: (base) => ({
      ...base,
      color: modalTextColor,
    }),
    placeholder: (base) => ({
      ...base,
      color: inputPlaceholderColor,
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: '#e2e8f0',
      borderRadius: 'md',
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: modalTextColor,
      fontWeight: '500',
    }),
    multiValueRemove: (base) => ({
      ...base,
      color: 'gray.600',
      '&:hover': {
        backgroundColor: 'red.500',
        color: 'white',
      },
    }),
    input: (base) => ({
      ...base,
      color: inputTextColor,
    }),
    indicatorSeparator: (base) => ({
      ...base,
      backgroundColor: borderColor,
    }),
    dropdownIndicator: (base) => ({
      ...base,
      color: borderColor,
      '&:hover': {
        color: hoverBorderColor,
      },
    }),
  };
};
